export enum RoleEnum {
	farmer = 'farmer',
	tech = 'tech',
	admin = 'admin',
	super = 'super',
}
